import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "pi-intersect-fill",
  "use": "pi-intersect-fill-usage",
  "viewBox": "0 0 256 256",
  "content": "<symbol stroke=\"currentColor\" stroke-width=\"0\" viewBox=\"0 0 256 256\" xmlns=\"http://www.w3.org/2000/svg\" id=\"pi-intersect-fill\"><path d=\"M174.63 81.37a80 80 0 1 0-93.26 93.26 80 80 0 1 0 93.26-93.26ZM32 96a64 64 0 0 1 126-16 80.08 80.08 0 0 0-77.95 78A64.11 64.11 0 0 1 32 96Zm128 128a64.11 64.11 0 0 1-62-48 80.08 80.08 0 0 0 78-78 64 64 0 0 1-16 126Z\" stroke=\"none\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol